// Constants for mutation types
export const AUTH_SUCCESS = 'authSuccess'
export const AUTH_FAILED = 'authFailed'
export const AUTH_PASSED = 'authPassed'
export const CLEAN_ERROR = 'cleanErr'
